"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var EndPointsConfig_1 = require("./EndPointsConfig");
var PriceInfoResponseMapper_1 = require("../models/mappers/PriceInfoResponseMapper");
var CheckExistingTVAssociatedResponseMapper_1 = require("../models/mappers/CheckExistingTVAssociatedResponseMapper");
var ProcessRegistrationResponseMapper_1 = require("../models/mappers/ProcessRegistrationResponseMapper");
var ValidateCredentialResponseMapper_1 = require("../models/mappers/ValidateCredentialResponseMapper");
var InquireAssociatedAccessIDResponseMapper_1 = require("../models/mappers/InquireAssociatedAccessIDResponseMapper");
var RepCodeResponseMapper_1 = require("../models/mappers/RepCodeResponseMapper");
var PromoCodeResponseMapper_1 = require("../models/mappers/PromoCodeResponseMapper");
var ReportingService_1 = require("./ReportingService");
var NumberSelectionsReloadMapper_1 = require("../models/mappers/NumberSelectionsReloadMapper");
var AccountInfoMapper_1 = require("../models/mappers/AccountInfoMapper");
var AreaCodeMapper_1 = require("../models/mappers/AreaCodeMapper");
var AreaCodeCitiesMapper_1 = require("../models/mappers/AreaCodeCitiesMapper");
var FutureBillsResponseMapper_1 = require("../models/mappers/FutureBillsResponseMapper");
var LegalResponseMapper_1 = require("../models/mappers/LegalResponseMapper");
var Utils = require("../utils/UtilityFunctions");
var SaveCartResponseMapper_1 = require("../models/mappers/SaveCartResponseMapper");
var RetrieveCartResponseMapper_1 = require("../models/mappers/RetrieveCartResponseMapper");
var CheckoutApi_1 = require("./CheckoutApi");
var UserLoginRequiredResponseMapper_1 = require("../models/mappers/UserLoginRequiredResponseMapper");
var AddToCartMapper_1 = require("../models/mappers/AddToCartMapper");
var CartQuantityUpdateMapper_1 = require("../models/mappers/CartQuantityUpdateMapper");
var UserCurrentStateResponseMapper_1 = require("../models/mappers/UserCurrentStateResponseMapper");
var FeatureResponseMapper_1 = require("../models/mappers/FeatureResponseMapper");
var Api = /** @class */ (function (_super) {
    __extends(Api, _super);
    function Api() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Api.prototype.saveCart = function (saveCartPostData) {
        return this.networker.post(EndPointsConfig_1.default.saveCartApiUrl, saveCartPostData, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new SaveCartResponseMapper_1.SaveCartResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    Api.prototype.applyPromoCode = function (promoCodePostData, isWireless) {
        var endPointForPromoCode = isWireless ?
            EndPointsConfig_1.default.promoCodeForWirelessAPI :
            EndPointsConfig_1.default.promoCodePOSTAPI;
        return this.networker.post(endPointForPromoCode, promoCodePostData, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new PromoCodeResponseMapper_1.PromoCodeResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    Api.prototype.applyRepCode = function (repCodePostData) {
        return this.networker.post(EndPointsConfig_1.default.repCodePOSTAPI, repCodePostData, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new RepCodeResponseMapper_1.RepCodeResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    Api.prototype.getShareCartURL = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.networker.post(EndPointsConfig_1.default.shareCartAPI, {}, {
                        headers: Utils.getInitialHeaders(),
                    })
                        .then(function (data) {
                        return Promise.resolve(data);
                    })
                        .catch(function (err) {
                        return Promise.reject(err);
                    })];
            });
        });
    };
    Api.prototype.emptyAnyLOBCart = function (lobName) {
        return this.networker.post(EndPointsConfig_1.default.emptyCartMSAPI + lobName, {}, {
            headers: Utils.getInitialHeaders(),
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    Api.prototype.removeCheckoutOrderData = function () {
        return this.networker.delete(EndPointsConfig_1.default.removeOrderDataAPI, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (response) {
            return Promise.resolve(response);
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    Api.prototype.addToCart = function (postData) {
        return this.networker.post(EndPointsConfig_1.default.addToCartMSAPI, postData, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new AddToCartMapper_1.AddToCartMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    Api.prototype.validateZipCode = function (zipCode) {
        var postData = {
            updateCookie: true,
            zipCode: zipCode,
        };
        return this.networker.post(EndPointsConfig_1.default.validateZip, postData, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(data);
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    Api.prototype.convertPrepaidFromPostpaid = function (postData) {
        return this.networker.post(EndPointsConfig_1.default.convertPrepaidFromPostpaidMSAPI, postData, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new AddToCartMapper_1.AddToCartMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    Api.prototype.fetchLegalContentFromAEM = function (url) {
        if (url) {
            return this.networker.get(url, {
                headers: Utils.getInitialHeaders(),
            }, true)
                .then(function (data) {
                return Promise.resolve(new LegalResponseMapper_1.LegalResponseMapper(data).getDataObject());
            })
                .catch(function (err) {
                return Promise.reject(err);
            });
        }
        else {
            return Promise.reject(this);
        }
    };
    Api.prototype.getLegalContent = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.networker
                        .get(url, {
                        headers: Utils.getInitialHeaders(),
                    })
                        .then(function (response) {
                        return Promise.resolve(response);
                    })
                        .catch(function (err) {
                        return Promise.reject(err);
                    })];
            });
        });
    };
    Api.prototype.retrieveCart = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.networker.post(EndPointsConfig_1.default.retrieveCartUrl, value, {
                        headers: Utils.getInitialHeaders(),
                    })
                        .then(function (data) {
                        return Promise.resolve(new RetrieveCartResponseMapper_1.RetrieveCartResponseMapper(data).getDataObject());
                    })
                        .catch(function (err) {
                        return Promise.reject(err);
                    })];
            });
        });
    };
    Api.prototype.retrieveCartSummary = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.networker.get(url, {
                        headers: Utils.getInitialHeaders(),
                    })
                        .then(function (data) {
                        return Promise.resolve(new RetrieveCartResponseMapper_1.RetrieveCartResponseMapper(data).getDataObject());
                    })
                        .catch(function (err) {
                        return Promise.reject(err);
                    })];
            });
        });
    };
    // tslint:disable-next-line:no-any
    Api.prototype.getCartSummaryDetails = function () {
        return this.networker.get(EndPointsConfig_1.default.cartSummaryOLMSAPIURL, {
            headers: Utils.getInitialHeaders(),
        }).then(function (data) {
            return Promise.resolve(data);
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    Api.prototype.getSpoData = function (productCode, skuID, mode, productTypes, losgTypes, losgId, subscriberNumber) {
        var spoDataURL = "" + (Utils.getIxpFeatureFlagValue('svc-enable-azurepno-calls') ? EndPointsConfig_1.default.spoPNOMSAPI : EndPointsConfig_1.default.spoMSAPI) + productCode + "?skuId=" + skuID + "&mode=" + mode + "&productTypes=" + productTypes + "&losgTypes=" + losgTypes + "&productKey=" + productCode;
        if (losgId) {
            spoDataURL = spoDataURL + "&losgId=" + losgId;
        }
        if (subscriberNumber) {
            spoDataURL = spoDataURL + "&subscriber=" + subscriberNumber;
        }
        return this.networker.get(spoDataURL, {
            headers: Utils.getInitialHeaders(),
        }).then(function (data) {
            return Promise.resolve(data);
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    Api.prototype.getLnpDetails = function () {
        return this.networker.get(EndPointsConfig_1.default.lnpDetailsApi, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new NumberSelectionsReloadMapper_1.NumberSelectionsReloadMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    Api.prototype.getFutureBills = function () {
        return this.networker.get(EndPointsConfig_1.default.furtureBillsMSAPI, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new FutureBillsResponseMapper_1.FutureBillsResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    Api.prototype.getPriceInfo = function () {
        return this.networker.get(EndPointsConfig_1.default.priceinfoAPI, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new PriceInfoResponseMapper_1.PriceInfoResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    Api.prototype.checkExistingTVAssociated = function () {
        return this.networker.get(EndPointsConfig_1.default.checkExistingTVAssociated, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new CheckExistingTVAssociatedResponseMapper_1.CheckExistingTVAssociatedResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    Api.prototype.getAccountHolderInfo = function (losg) {
        return this.networker.get(EndPointsConfig_1.default.accountHolderInfo + losg, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new AccountInfoMapper_1.AccountInfoMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    Api.prototype.inquireAssociatedAccessID = function (body) {
        var _this = this;
        return this.networker.post(EndPointsConfig_1.default.inquireAssociatedAccessID, body, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new InquireAssociatedAccessIDResponseMapper_1.InquireAssociatedAccessIDResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            _this.reportingService.fireVerifyAccessIDActionEvent(true, err && err.error && err.error.errorId, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, body.email, JSON.stringify(err));
            _this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.ACCESSID_PAGE);
            return Promise.reject(err);
        });
    };
    Api.prototype.createAID = function (body) {
        var _this = this;
        return this.networker.post(EndPointsConfig_1.default.processRegistration, body, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new ProcessRegistrationResponseMapper_1.ProcessRegistrationResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            // Analytics Code: form response for NewAccessIDForm
            _this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.ACCESSID_PAGE);
            return Promise.reject(err);
        });
    };
    Api.prototype.validateCredentails = function (body) {
        var _this = this;
        return this.networker.post(EndPointsConfig_1.default.validateCredentials, body, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new ValidateCredentialResponseMapper_1.ValidateCredentialResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            _this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.ACCESSID_PAGE);
            return Promise.reject(err);
        });
    };
    Api.prototype.getAreaCodesByZipCode = function (zipCodeOrAreaCode, isNumberManagementEnabled) {
        var endPoint = isNumberManagementEnabled ? EndPointsConfig_1.default.areaCodeByAreaCodeOrZipCodeNumber
            : EndPointsConfig_1.default.areaCodeByAreaCodeOrZipCode;
        endPoint += "zipcode=" + zipCodeOrAreaCode;
        if (Utils.isFirstNetCaribbean()) {
            endPoint += "&serviceType=FN";
        }
        return this.networker.get(endPoint, {
            headers: Utils.getInitialHeaders(),
        }, true)
            .then(function (data) {
            return Promise.resolve(new AreaCodeMapper_1.AreaCodeMapper(isNumberManagementEnabled ?
                { content: data } : data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    Api.prototype.getMarketByAreaCode = function (zipCodeOrAreaCode, isNumberManagementEnabled) {
        var endPoint = isNumberManagementEnabled
            ? EndPointsConfig_1.default.areaCodeByAreaCodeOrZipCodeNumber
            : EndPointsConfig_1.default.areaCodeByAreaCodeOrZipCode;
        endPoint += "areacode=" + zipCodeOrAreaCode;
        if (Utils.isFirstNetCaribbean()) {
            endPoint += "&serviceType=FN";
        }
        return this.networker.get(endPoint, {
            headers: Utils.getInitialHeaders(),
        }, true)
            .then(function (data) {
            var responseData = isNumberManagementEnabled ? { content: data } : data;
            return Promise.resolve(new AreaCodeCitiesMapper_1.AreaCodeCitiesMapper(responseData).getDataObject());
        })
            .catch(function (err) { return Promise.reject(err); });
    };
    /**
     * Checks Line Number Portability Eligibility
     * @param ctnArray
     */
    Api.prototype.validateEligibility = function (ctnArray) {
        return __awaiter(this, void 0, void 0, function () {
            var portEligRequest, validateEligibilityUrl;
            return __generator(this, function (_a) {
                portEligRequest = { mobileInfoList: ctnArray };
                validateEligibilityUrl = EndPointsConfig_1.default.validateNumberApiUrl
                    + encodeURI(JSON.stringify(portEligRequest));
                if (Utils.IsBsseFlow()) {
                    try {
                        return [2 /*return*/, this.networker.post(EndPointsConfig_1.default.bsseValidateNumberApiUrl, {
                                portEligibilityRequest: { requestId: 'CAAS', telephoneNumbers: ctnArray.map(function (arr) {
                                        return { telephoneNumber: arr.ctn };
                                    }) },
                            }, {
                                headers: Utils.getInitialHeaders(),
                            })
                                .then(function (data) {
                                return Promise.resolve(data);
                            })
                                .catch(function (err) {
                                return Promise.reject(err);
                            })];
                    }
                    catch (e) {
                        return [2 /*return*/, Promise.reject(e)];
                    }
                }
                return [2 /*return*/, this.networker.get(validateEligibilityUrl, {
                        headers: Utils.getInitialHeaders(),
                    }, true)
                        .then(function (data) {
                        return Promise.resolve(data);
                    })
                        .catch(function (err) {
                        return Promise.reject(err);
                    })];
            });
        });
    };
    /*
    * New API for check LNP eligibility
    *
    */
    Api.prototype.validatePortingEligibility = function (ctnNumber) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.networker.post(EndPointsConfig_1.default.checkPortEligibilityApi, { ctn: ctnNumber }, { headers: Utils.getInitialHeaders() })
                        .then(function (data) {
                        return Promise.resolve(data);
                    })
                        .catch(function (err) {
                        return Promise.reject(err);
                    })];
            });
        });
    };
    /*
     * New API for check LNP eligibility
     *
     */
    Api.prototype.validatePortInEligibility = function (ctnNumber) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.networker.post(EndPointsConfig_1.default.checkPortEligibilityNewApi, { mobileInfoList: [{ ctn: ctnNumber }] }, { headers: Utils.getInitialHeaders() })
                        .then(function (data) {
                        return Promise.resolve(data);
                    })
                        .catch(function (err) {
                        return Promise.reject(err);
                    })];
            });
        });
    };
    /**
     * Checks Line VOIP Number Eligibility
     * @param telephoneNumber
     */
    Api.prototype.validateVoipEligibility = function (reqPayload) {
        return this.networker.post(EndPointsConfig_1.default.validateVoipNumberApiUrl, reqPayload, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(data);
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    Api.prototype.getLoginRequiredOrNot = function () {
        return this.networker.get(EndPointsConfig_1.default.loginRequiredMSAPI, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new UserLoginRequiredResponseMapper_1.UserLoginRequiredResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    Api.prototype.postLoginActionInCheckout = function (isSkipped, authenticatedState) {
        var loginAction = {
            loginSelectionInfo: {
                authenticationStatus: (authenticatedState === 'Y') ? 'success' :
                    (authenticatedState === 'N') ? 'failure' : undefined,
                continueAsGuest: isSkipped ? 'Y' : undefined,
                loginOffered: 'Y',
            },
        };
        return this.networker.post(EndPointsConfig_1.default.postLoginStepMSAPI, loginAction, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new UserLoginRequiredResponseMapper_1.UserLoginRequiredResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    Api.prototype.updateStreamingDevicesInCart = function (postData) {
        return this.networker.post(EndPointsConfig_1.default.updateStreamingDeviceInCart, postData, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new CartQuantityUpdateMapper_1.CartQuantityUpdateMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    Api.prototype.updateOspreyQuantityInCart = function (postData) {
        return this.networker.post(EndPointsConfig_1.default.updateOspreyQuantityInCart, postData, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new CartQuantityUpdateMapper_1.CartQuantityUpdateMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    Api.prototype.getUserCurrentState = function () {
        return this.networker.get(EndPointsConfig_1.default.getUserCurrentState, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new UserCurrentStateResponseMapper_1.UserCurrentStateResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    Api.prototype.getIdmFeatureToggle = function () {
        return this.networker.get(EndPointsConfig_1.default.idmFeatureAPI, {
            headers: Utils.getInitialHeaders(),
        })
            .then(function (data) {
            return Promise.resolve(new FeatureResponseMapper_1.FeatureResponseMapper(data).getDataObject());
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    return Api;
}(CheckoutApi_1.default));
exports.default = Api;
//# sourceMappingURL=Api.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/api/Api.js
// module id = 223
// module chunks = 8